import {Observable} from "rxjs";

export abstract class BaseEntitiesResolver<T> {
    abstract resolve(): Observable<T[]>;
}
